
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import _Link from 'next/link'
import { Heading as _Heading } from '@/components/Heading'
const meta = {};
const slug = '_channel';
const tableOfContents = [{
  "title": "Channels which you can allow booking",
  "slug": "channels-which-you-can-allow-booking",
  "children": []
}];

const layoutProps = {
  meta,
slug,
tableOfContents
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <_Heading level={2} id={"channels-which-you-can-allow-booking"} nextElement={{
      "type": "list",
      "ordered": false,
      "start": null,
      "spread": false
    }}>Channels which you can allow booking</_Heading>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Website `}</li>
      <li parentName="ul">{`Android App`}</li>
      <li parentName="ul">{`iOS App`}</li>
      <li parentName="ul">{`iPad App `}</li>
      <li parentName="ul">{`Android Kiosk App`}</li>
    </ul>



    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps
